import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * ページングを日本語で表示する。
 * @export
 * @class MatPaginatorIntlJa
 */
@Injectable({
  providedIn: 'root'
})
export class MatPaginatorIntlJa extends MatPaginatorIntl {
  itemsPerPageLabel = '表示件数：';
  nextPageLabel = '次へ';
  previousPageLabel = '戻る';

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) { return `検索結果：${length} 件`; }

    const amountPages = Math.ceil(length / pageSize);
    return `検索結果：${length} 件　 ${page + 1} / ${amountPages} ページ`;
  }
}